/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Name_TitleInputs */

const en_common_sign_name_title = /** @type {(inputs: Common_Sign_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const zh_common_sign_name_title = /** @type {(inputs: Common_Sign_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Common_Sign_Name_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_name_title = /** @type {((inputs?: Common_Sign_Name_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Name_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_name_title(inputs)
	return zh_common_sign_name_title(inputs)
});
export { common_sign_name_title as "common.sign.name_title" }